import React, { useContext } from 'react';
import { Button, Col, Container, Form, Image, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { UserContext } from '../../App';
import Map from '../../images/Map.png';

const Destination = () => {
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    const { riderType } = useParams();
    // const today = new Date(),
    // date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    return (
        <div>
            <Container>



            <h1>Let's Book a {riderType} </h1>
            <h2>Hello, {loggedInUser.name}</h2>
            <Button variant="success" onClick={() => setLoggedInUser({})}>Sign Out</Button>
            
            <br/>
                <Row>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Control as="select">
                                <option>Pick From</option>
                                {/* {date} <br/> */}
                                <option>Current Location</option>
                            </Form.Control>
                            <br />
                            <Form.Control as="select">
                                <option>Pick To</option>
                                <option>Cox Bazar</option>                                
                                <option>Sylhet</option>
                                <option>Rajshahi</option>
                                <option>Barishal</option>
                            </Form.Control>
                            <br />
                            <Button variant="success">Search</Button>
                        </Form.Group>
                    </Col>
                </Row>
            </Container>

            <Container>
                <Row>

                    <Col md={6}>
                        <Image src={Map} alt=""></Image>
                    </Col>
                </Row>
            </Container>



        </div>
    );
};

export default Destination;